export default "__VITE_ASSET__8SaZdNIs__"